import React from "react";
import { window } from "global";
import { useGlobal } from "reactn";
import { MediaQuery } from "@outplayed/responsive";
import { ReactComponent as SearchIconWhite } from "svg/search-icon-2-white.svg";
import { ReactComponent as SearchIconWhiteLightMode } from "svg/search-icon-2-light-mode.svg";
import { ReactComponent as UggLogoU } from "svg/logos/ugg-u-logo.svg";
import { ReactComponent as HamburgerMenu } from "svg/hamburger-menu.svg";
import FeedbackIcon from "./Masthead/Feedback/FeedbackIcon";
import Searchbar from "./Searchbar";
import { useLightMode } from "hooks/general-hooks";
import LightModeToggle from "./Masthead/LightModeToggle";
import NotificationContainer from "./Masthead/Notifications/NotificationContainer";
import classNames from "classnames";

const Masthead = (props) => {
  const { sideNavOpen, setSideNavOpen, setAutoSearch } = props;
  const [verificationBar] = useGlobal("verificationBar");
  const { lightModeOn } = useLightMode();

  const collapsed = sideNavOpen ? "expanded" : "collapsed";

  const autoSearch = () => {
    setAutoSearch(true);
    setSideNavOpen(true);
  };

  const verificationBarActive = verificationBar ? "verification-bar-active" : "";

  if (!window) {
    return (
      <div id="masthead" className={`${props.isLandingPage ? "landing transparent" : ""}`}>
        <div className={`masthead-container`}></div>
      </div>
    );
  }

  return (
    <div id="masthead" className={`${verificationBarActive} ${props.isLandingPage ? "landing transparent" : ""}`}>
      <div className={"masthead-container " + collapsed}>
        <MediaQuery min="MOBILE_SMALL" max="MOBILE_LARGE">
          <div className="mobile-logo">
            <HamburgerMenu className="hamburger" onClick={() => setSideNavOpen(!sideNavOpen)} />
            <a href="https://u.gg">
              <div className="masthead-ugg-logo">
                <UggLogoU style={{ height: "38px", width: "19.19px" }} />
              </div>
            </a>
          </div>
        </MediaQuery>
        <div
          className={classNames("masthead-search-bar-container", {
            "dark-theme": !lightModeOn,
            "light-theme": lightModeOn,
          })}
        >
          {!props.isLandingPage && <Searchbar placeholder={"Search a Hero"} />}
        </div>
        <MediaQuery min="TABLET" max="DESKTOP_LARGE">
          <div className="masthead-right">
            <LightModeToggle />
            <FeedbackIcon />
            <NotificationContainer />
          </div>
        </MediaQuery>
        <MediaQuery min="MOBILE_LARGE" max="MOBILE_LARGE">
          <div className="masthead-right" style={{ marginLeft: "-16px" }}>
            <FeedbackIcon />
            <NotificationContainer />
          </div>
        </MediaQuery>
        <MediaQuery min="MOBILE_SMALL" max="MOBILE_MEDIUM">
          <div className="masthead-right" style={{ marginLeft: "-16px" }}>
            {!props.isLandingPage &&
              (lightModeOn ? (
                <SearchIconWhiteLightMode style={{ height: "16px", width: "16px" }} onClick={autoSearch} />
              ) : (
                <SearchIconWhite style={{ height: "16px", width: "16px" }} onClick={autoSearch} />
              ))}
            <FeedbackIcon />
            <NotificationContainer />
          </div>
        </MediaQuery>
      </div>
    </div>
  );
};

export default Masthead;
